import { render } from "./Solvents.vue?vue&type=template&id=c11d3316"
import script from "./Solvents.vue?vue&type=script&lang=js"
export * from "./Solvents.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__